import { ThemeProvider } from 'styled-components';
import { QueryClientProvider, QueryClient } from 'react-query';

import { theme } from '../../assets/style/theme';
import GrobalStyle from '../../assets/style/global-style';

import logow from '../../assets/images/logo_w.png';
import logowEn from '../../assets/images/logo_w_en.png';
import Nav from '../SiteHeader/Nav';
import { SiteFooterSection } from './style';
import FooterInfo from './FooterInfo';

import { FootNavSection, SnsNavSection } from '../SiteHeader/Nav/style';
import { Image } from '@chakra-ui/react';


const queryClient = new QueryClient();

type Props = {
};

function SiteFooter({  }: Props) {

  const onHover = (id:number) => {		
    
  }

  const onChangeLink = (e:any) => {		
    window?.open(e.target.value, '_blank')?.focus();
  }

  const isEnglish = window.__LANG__ === 'en';

  return (
    <>
    <ThemeProvider theme={theme}>
    <GrobalStyle />
    <QueryClientProvider client={queryClient}>
      <SiteFooterSection>
        <section>
          <nav className="nav">
            <FootNavSection>
              <Nav slug={isEnglish ? 'footnav_en' : 'footnav'} onHover={onHover} />
            </FootNavSection>
            
            <select onChange={onChangeLink} value="">
              <option value="">
                {isEnglish ? 'Regulatory Agency for Public Interest Violations' : '공익위반사항 관리감독 기관'}
              </option>
              <option value="https://www.acrc.go.kr/">국민권익위원회 </option>
              <option value="http://www.me.go.kr/">환경부</option>
              <option value="https://www.nts.go.kr/">국세청</option>
            </select>
          </nav>

          <div className="info">
            <h1 className="logo">
              <img src={isEnglish ? logowEn : logow} alt="재단법인 숲과나눔" width="216" />
            </h1>
            <section>
              <FooterInfo />
              <SnsNavSection>
                <Nav slug="sns" type="icon" target="_blank" onHover={onHover} />
              </SnsNavSection>
            </section>
          </div>
        </section>
        {
          !isEnglish && (
            <div className="floating-banner">
              <a href="/donation">
                <Image src="/images/main/floating_banner.png" />
              </a>
              <div className="footer-social-banner">
                <a href="https://blog.naver.com/korea_she" target="_blank"><i className="xi-naver"></i></a>
                <a href="https://www.facebook.com/koreashe" target="_blank"><i className="xi-facebook"></i></a>
                <a href="http://www.instagram.com/korea.she" target="_blank"><i className="xi-instagram"></i></a>
                <a href="https://www.youtube.com/channel/UCrbYikiqpJAXv8xmYhzV-yw" target="_blank"><i className="xi-youtube-play"></i></a>
              </div>
            </div>
          )
        }
      </SiteFooterSection>
    </QueryClientProvider>
    </ThemeProvider>
    </>
  );
}

SiteFooter.defaultProps = {
};

export default SiteFooter;
